<template>
  <button
    v-on:click="toggleMenu(menuItem.id, menuItem.childSortOrder)"
    :aria-expanded="expanded"
    :aria-label="showLinksText + ' ' + menuItem.name"
  >
    <span>
      <Icon :type="icon"></Icon>
    </span>
  </button>
</template>
<script>
import Icon from "../../image/icon.vue";
export default {
  name: "MenuButton",
  props: {
    menuItem: Object,
    showLinksText: String,
    expanded: Boolean,
  },
  emits: {
    toggleMenu: null
  },
  data: function () {
    return {
      icon: "",
    };
  },
  components: {
    Icon,
  },
  created() {
    this.getIcon();
  },
  methods: {
    toggleMenu(id, sort) {
      this.$emit("toggleMenu", id, sort);
    },
    getIcon() {
      if (this.expanded) {
        this.icon = "minus";
      } else {
        this.icon = "plus";
      }
    },
  },
  watch: {
    expanded() {
      this.getIcon();
    },
  },
};
</script>
